module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/file-icons/pdf.svg?f87d0bb72fd491acb7c3477574a81a3b";